import { Form, Formik } from 'formik';
import { otpValidation } from '@/utils/valitation/auth';

import FormField from '../FormField';

const Otp = ({ t, setAuth, onSetOtp }) => {
  const handleLogin = async (values) => {
    onSetOtp(values.otp);
    setAuth('Change Password');
  };
  return (
    <section className='mt-3 sm:mt-5'>
      <p className='text-center text-sm *:ms-1 sm:text-lg'>
        <span className='font-bold text-primary'>{t('Enter your OTP')}</span>
        <span className='text-[#787272]'>
          , {t('sent to your email address')}
        </span>
      </p>
      <Formik
        onSubmit={handleLogin}
        initialValues={{
          otp: '',
        }}
        validationSchema={otpValidation}
      >
        {({ errors, touched }) => (
          <Form>
            <div className='my-2 sm:my-4'>
              <FormField
                inputClassName='w-full rounded-md border p-1.5 max-sm:placeholder:text-sm max-sm:text-sm sm:p-2 outline-none'
                placeholder={t('Otp')}
                name='otp'
                dir={'ltr'}
                errorClassName='text-red-600 text-sm mt-1 max-sm:text-xs'
                t={t}
                errors={errors}
                touched={touched}
              />
            </div>
            <button className='w-full rounded-md bg-primary p-2 font-semibold text-white max-sm:text-sm'>
              {t('Send')}
            </button>
          </Form>
        )}
      </Formik>
    </section>
  );
};

export default Otp;
